import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-svg-loader',
  templateUrl: './svg-loader.component.html',
  styleUrls: ['./svg-loader.component.css']
})
export class SvgLoaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
